import { useState } from 'react';
import axios from 'axios';
import './styles/auth.css';

import CAMPUS_IMG from './assets/kampus_A.png';
import ikona from './assets/icon.png';

function RegisterForm({ onBackToLogin }) {
    const [login, setLogin] = useState('');
    const [haslo, setHaslo] = useState('');
    const [blad, setBlad] = useState('');
    const [sukces, setSukces] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBlad('');
        setSukces('');

        try {
            const res = await axios.post('/api/uzytkownicy/zarejestruj', { login, haslo });
            setSukces(res.data.komunikat || 'Rejestracja udana! Możesz się zalogować.');
        } catch (err) {
            setBlad(err.response?.data?.blad || 'Błąd rejestracji');
        }
    };

    return (
        <div
            className="auth-hero-bg"
            style={{ backgroundImage: `url("${CAMPUS_IMG}")` }}
            role="img"
            aria-label="Zdjęcie kampusu uczelni w tle"
        >
            <div className="auth-glass">
                <div className="auth-head">
                    <div className="auth-badge" aria-hidden style={{ background: 'rgba(255,255,255,.14)' }}>
                        <img src={ikona} alt="" style={{ height: 28, width: 28, objectFit: 'contain' }} />
                    </div>
                    <div>
                        <h1 className="auth-title">Załóż konto</h1>
                        <div className="auth-sub">Zarejestruj się, aby korzystać z platformy egzaminacyjnej</div>
                    </div>
                </div>

                <div className="auth-msg">
                    {!!blad && <div className="auth-err">{blad}</div>}
                    {!!sukces && <div className="auth-ok">{sukces}</div>}
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="reg-login" className="auth-label">E-mail</label>
                        <div className="auth-input-wrap">
                            <input
                                id="reg-login"
                                className="auth-input"
                                type="email"
                                placeholder="np. jan.kowalski@wsz.pl"
                                value={login}
                                onChange={(e) => setLogin(e.target.value)}
                                autoComplete="email"
                                required
                            />
                        </div>
                    </div>

                    <div className="auth-field">
                        <label htmlFor="reg-haslo" className="auth-label">Hasło</label>
                        <div className="auth-input-wrap">
                            <input
                                id="reg-haslo"
                                className="auth-input"
                                type="password"
                                placeholder="minimum 8 znaków"
                                value={haslo}
                                onChange={(e) => setHaslo(e.target.value)}
                                autoComplete="new-password"
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" className="auth-cta" style={{ marginTop: 12 }}>
                        Utwórz konto
                    </button>
                </form>

                <div className="auth-foot" style={{ marginTop: 10 }}>
                    Masz już konto?{' '}
                    <button className="auth-link" onClick={onBackToLogin}>
                        Wróć do logowania
                    </button>
                </div>
            </div>

            <div className="auth-legal">
                © {new Date().getFullYear()} Gdańska Akademia Medyczna Nauk Stosowanych
            </div>
        </div>
    );
}

export default RegisterForm;
